var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSparkMono = function SvgSparkMono(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9L20.75 6.25L23.5 5L20.75 3.75L19.5 1L18.25 3.75L15.5 5L18.25 6.25L19.5 9ZM19.5 15L18.25 17.75L15.5 19L18.25 20.25L19.5 23L20.75 20.25L23.5 19L20.75 17.75L19.5 15ZM12 9.5L9.5 4L7 9.5L1.5 12L7 14.5L9.5 20L12 14.5L17.5 12L12 9.5ZM10.49 12.99L9.5 15.17L8.51 12.99L6.33 12L8.51 11.01L9.5 8.83L10.49 11.01L12.67 12L10.49 12.99Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSparkMono);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjUgOUwyMC43NSA2LjI1TDIzLjUgNUwyMC43NSAzLjc1TDE5LjUgMUwxOC4yNSAzLjc1TDE1LjUgNUwxOC4yNSA2LjI1TDE5LjUgOVpNMTkuNSAxNUwxOC4yNSAxNy43NUwxNS41IDE5TDE4LjI1IDIwLjI1TDE5LjUgMjNMMjAuNzUgMjAuMjVMMjMuNSAxOUwyMC43NSAxNy43NUwxOS41IDE1Wk0xMiA5LjVMOS41IDRMNyA5LjVMMS41IDEyTDcgMTQuNUw5LjUgMjBMMTIgMTQuNUwxNy41IDEyTDEyIDkuNVpNMTAuNDkgMTIuOTlMOS41IDE1LjE3TDguNTEgMTIuOTlMNi4zMyAxMkw4LjUxIDExLjAxTDkuNSA4LjgzTDEwLjQ5IDExLjAxTDEyLjY3IDEyTDEwLjQ5IDEyLjk5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";